webpackJsonp([35783957827783],{

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: 100%;\n  justify-content: center;\n\n'], ['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: 100%;\n  justify-content: center;\n\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex:0 1 960px;\n  flex-direction: row;\n  justify-content: space-around;\n  padding: 10px;\n'], ['\n  display: flex;\n  flex:0 1 960px;\n  flex-direction: row;\n  justify-content: space-around;\n  padding: 10px;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n\n'], ['\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  ', '\n  max-width: 200px;\n  filter:grayscale(100);\n  transition: 0.3s;\n  &:hover {\n    filter:grayscale(0);\n  }\n'], ['\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  ', '\n  max-width: 200px;\n  filter:grayscale(100);\n  transition: 0.3s;\n  &:hover {\n    filter:grayscale(0);\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _plnu = __webpack_require__(444);
	
	var _plnu2 = _interopRequireDefault(_plnu);
	
	var _uci = __webpack_require__(446);
	
	var _uci2 = _interopRequireDefault(_uci);
	
	var _mbari = __webpack_require__(443);
	
	var _mbari2 = _interopRequireDefault(_mbari);
	
	var _roosevelt = __webpack_require__(445);
	
	var _roosevelt2 = _interopRequireDefault(_roosevelt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	
	var Affiliations_Section = function Affiliations_Section(props) {
	  return _react2.default.createElement(
	    _Container2.default,
	    { small: true },
	    _react2.default.createElement(
	      FlexRow,
	      null,
	      _react2.default.createElement(
	        LogoContainer,
	        null,
	        _react2.default.createElement(
	          LogoLink,
	          { href: 'https://www.pointloma.edu/',
	            target: '_blank' },
	          _react2.default.createElement(Logo, { src: _plnu2.default })
	        ),
	        _react2.default.createElement(
	          LogoLink,
	          { href: 'https://uci.edu/',
	            target: '_blank' },
	          _react2.default.createElement(Logo, { src: _uci2.default })
	        ),
	        _react2.default.createElement(
	          LogoLink,
	          { href: 'https://www.mbari.org/',
	            target: '_blank' },
	          _react2.default.createElement(Logo, { src: _mbari2.default })
	        ),
	        _react2.default.createElement(
	          LogoLink,
	          { href: 'https://www.roosevelt.edu/',
	            target: '_blank' },
	          _react2.default.createElement(Logo, { src: _roosevelt2.default })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Affiliations_Section;
	
	
	var FlexRow = _styledComponents2.default.div(_templateObject);
	
	var LogoContainer = _styledComponents2.default.div(_templateObject2);
	
	var LogoLink = _styledComponents2.default.a(_templateObject3);
	
	var Logo = _styledComponents2.default.img(_templateObject4, '' /* margin: 0px 20px; */);
	module.exports = exports['default'];

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mbari.12cfcd56.jpg";

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/plnu.87cd87e3.jpg";

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roosevelt.e0d445f1.jpg";

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uci.9a09f255.jpg";

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 600px;\n'], ['\n  width: 600px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  line-height: 1.4rem;\n  font-size: 1.15rem;\n  font-family: Lato;\n  font-weight: 300;\n  opacity: 1;\n  text-align: center;\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n\n  & a {\n    color: inherit;\n  }\n\n  & h3 {\n    margin-bottom: 0.5rem;\n  }\n\n   @media (max-width: 600px) {\n     font-size: 1rem;\n     line-height: 1.25rem;\n   }\n'], ['\n  line-height: 1.4rem;\n  font-size: 1.15rem;\n  font-family: Lato;\n  font-weight: 300;\n  opacity: 1;\n  text-align: center;\n  letter-spacing: 0.25px;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n\n  & a {\n    color: inherit;\n  }\n\n  & h3 {\n    margin-bottom: 0.5rem;\n  }\n\n   @media (max-width: 600px) {\n     font-size: 1rem;\n     line-height: 1.25rem;\n   }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _Card = __webpack_require__(30);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var Contact_Section = function Contact_Section(props) {
	  return _react2.default.createElement(
	    _Container2.default,
	    { small: true, blue: true },
	    console.log(marked(props.text)),
	    _react2.default.createElement(
	      _InnerContainer2.default,
	      { light: true },
	      _react2.default.createElement(
	        _SectionHeader2.default,
	        { light: true },
	        'Contact Info'
	      ),
	      _react2.default.createElement(SectionText, { dangerouslySetInnerHTML: { __html: marked(props.text, { sanitize: true }) }
	      })
	    )
	  );
	};
	
	exports.default = Contact_Section;
	
	
	var ContactCard = _Card2.default.extend(_templateObject);
	
	var SectionText = _styledComponents2.default.div(_templateObject2);
	module.exports = exports['default'];

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  font-size: 4rem;\n  line-height: 5.5rem;\n  margin: 0;\n\n  @media (max-width: 900px) {\n    font-size: 3rem;\n    line-height: 3.5rem;\n  }\n\n  @media (max-width: 600px) {\n    font-size: 2.25rem;\n    line-height: 2.5rem;\n  }\n'], ['\n  font-weight: 300;\n  font-size: 4rem;\n  line-height: 5.5rem;\n  margin: 0;\n\n  @media (max-width: 900px) {\n    font-size: 3rem;\n    line-height: 3.5rem;\n  }\n\n  @media (max-width: 600px) {\n    font-size: 2.25rem;\n    line-height: 2.5rem;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  font-size: 2rem;\n  line-height: 2.5rem;\n  margin: 0 0 1rem;\n  opacity: 1;\n  ', '\n\n  @media (max-width: 900px) {\n    margin: 0.5rem 0;\n  }\n\n  @media (max-width: 600px) {\n    font-size: 1.5rem;\n    line-height: 2rem;\n  }\n'], ['\n  font-weight: 300;\n  font-size: 2rem;\n  line-height: 2.5rem;\n  margin: 0 0 1rem;\n  opacity: 1;\n  ', '\n\n  @media (max-width: 900px) {\n    margin: 0.5rem 0;\n  }\n\n  @media (max-width: 600px) {\n    font-size: 1.5rem;\n    line-height: 2rem;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  line-height: 1.85rem;\n  font-size: 1.35rem;\n  font-family: Lato;\n  font-weight: 300;\n  letter-spacing: 0.25px;\n\n  ', '\n\n  @media (max-width: 600px) {\n    font-size: 1.25rem;\n    line-height: 1.5rem;\n  }\n'], ['\n  line-height: 1.85rem;\n  font-size: 1.35rem;\n  font-family: Lato;\n  font-weight: 300;\n  letter-spacing: 0.25px;\n\n  ', '\n\n  @media (max-width: 600px) {\n    font-size: 1.25rem;\n    line-height: 1.5rem;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var Hero_Section = function Hero_Section(props) {
	  return _react2.default.createElement(
	    _Container2.default,
	    { hero: true },
	    _react2.default.createElement(
	      _InnerContainer2.default,
	      { light: true, centered: true },
	      _react2.default.createElement(
	        HeroTitle,
	        null,
	        'Amy E. Zimmerman, Ph.D.'
	      ),
	      _react2.default.createElement(
	        HeroSubtitle,
	        null,
	        'Microbial Ecology & Biogeochemistry'
	      ),
	      _react2.default.createElement(SectionText, { dangerouslySetInnerHTML: { __html: marked(props.text, { sanitize: true }) } })
	    )
	  );
	};
	
	exports.default = Hero_Section;
	
	// const Container = styled.div`
	//   background: linear-gradient(rgba(46, 139, 87,.85),rgba(46, 139, 87,.85)),url(${logo});
	//   display: flex;
	//   flex-direction: column;
	//   justify-content: center;
	//   padding: 10px;
	//   height: 75vh;
	//   min-height: 500px;
	//   background-size: cover;
	//   background-position: center;
	//   background-repeat: no-repeat;
	//   font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
	// `;
	
	// const InnerContainer = styled.div`
	//   max-width: 960px;
	//   margin: auto;
	//   padding: 20px;
	//   text-align: center;
	//   color: white;
	// `;
	
	var HeroTitle = _styledComponents2.default.h1(_templateObject);
	
	var HeroSubtitle = _styledComponents2.default.h4(_templateObject2, '' /* text-transform: uppercase; */);
	
	var SectionText = _styledComponents2.default.div(_templateObject3, '' /* @media (max-width: 900px) {
	                                                                      font-size: 2rem;
	                                                                      line-height: 2.5rem;
	                                                                      } */);
	module.exports = exports['default'];

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin: 0px 0px 10px;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n  border-left: 5px solid ', ';\n'], ['\n  margin: 0px 0px 10px;\n  &:last-of-type {\n    margin-bottom: 20px;\n  }\n  border-left: 5px solid ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n'], ['\n  font-weight: 300;\n  line-height: 1.8rem;\n  font-size: 1.5rem;\n  margin: 0px 0px .5rem;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.8;\n'], ['\n  line-height: 1.5rem;\n  font-size: 1rem;\n  margin: 0px 0px .5rem;\n  font-weight: 500;\n  opacity: 0.8;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n'], ['\n  line-height: 1.5rem;\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0px 0px 0;\n  opacity: 0.8;\n  & p:last-of-type {\n    margin-bottom: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Card = __webpack_require__(30);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var marked = __webpack_require__(12);
	marked.setOptions({
	  gfm: true,
	  tables: true,
	  breaks: true,
	  sanitize: true
	});
	
	var News_Item = function News_Item(props) {
	  return _react2.default.createElement(
	    NewsCard,
	    { type: props.news.type && props.news.type[0] },
	    _react2.default.createElement(
	      NewsDate,
	      null,
	      new Date(props.news.date).toLocaleDateString()
	    ),
	    _react2.default.createElement(
	      NewsTitle,
	      null,
	      props.news.title
	    ),
	    props.news.description && _react2.default.createElement(NewsDetails, {
	      dangerouslySetInnerHTML: { __html: marked(props.news.description.description, { sanitize: true }) } })
	  );
	};
	
	exports.default = News_Item;
	
	
	var NewsCard = _Card2.default.extend(_templateObject, function (props) {
	  return props.type == 'Award' && 'gold' || props.type == 'Meeting' && 'rebeccapurple' || props.type == 'Position' && 'tomato' || props.type == 'Poster' && 'mediumseagreen' || props.type == 'Presentation' && 'steelblue' || props.type == 'Publication' && 'lightblue' || '#333';
	});
	
	var NewsTitle = _styledComponents2.default.h2(_templateObject2);
	
	var NewsDate = _styledComponents2.default.p(_templateObject3);
	
	var NewsDetails = _styledComponents2.default.p(_templateObject4);
	module.exports = exports['default'];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _News_Item = __webpack_require__(74);
	
	var _News_Item2 = _interopRequireDefault(_News_Item);
	
	var _Container = __webpack_require__(20);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _InnerContainer = __webpack_require__(15);
	
	var _InnerContainer2 = _interopRequireDefault(_InnerContainer);
	
	var _SectionHeader = __webpack_require__(24);
	
	var _SectionHeader2 = _interopRequireDefault(_SectionHeader);
	
	var _SectionLink = __webpack_require__(202);
	
	var _SectionLink2 = _interopRequireDefault(_SectionLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var marked = __webpack_require__(12);
	
	var News_Section = function News_Section(props) {
	  return _react2.default.createElement(
	    _Container2.default,
	    null,
	    _react2.default.createElement(
	      _InnerContainer2.default,
	      null,
	      _react2.default.createElement(
	        _SectionHeader2.default,
	        null,
	        'News and Updates'
	      ),
	      _react2.default.createElement(_News_Item2.default, { news: props.news[0].node }),
	      _react2.default.createElement(_News_Item2.default, { news: props.news[1].node }),
	      _react2.default.createElement(_News_Item2.default, { news: props.news[2].node }),
	      _react2.default.createElement(
	        _SectionLink2.default,
	        { to: '/news/' },
	        ' See More '
	      )
	    )
	  );
	};
	
	exports.default = News_Section;
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: rebeccapurple;\n  letter-spacing: 0.25px;\n  margin-top: 20px;\n  &:hover {\n    opacity: 0.8;\n    text-decoration: underline;\n  }\n  &:visited {\n    color: rebeccapurple;\n  }\n'], ['\n  color: rebeccapurple;\n  letter-spacing: 0.25px;\n  margin-top: 20px;\n  &:hover {\n    opacity: 0.8;\n    text-decoration: underline;\n  }\n  &:visited {\n    color: rebeccapurple;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var SectionLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject);
	
	exports.default = SectionLink;
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Hero_Section = __webpack_require__(197);
	
	var _Hero_Section2 = _interopRequireDefault(_Hero_Section);
	
	var _News_Section = __webpack_require__(198);
	
	var _News_Section2 = _interopRequireDefault(_News_Section);
	
	var _Affiliations_Section = __webpack_require__(192);
	
	var _Affiliations_Section2 = _interopRequireDefault(_Affiliations_Section);
	
	var _Contact_Section = __webpack_require__(194);
	
	var _Contact_Section2 = _interopRequireDefault(_Contact_Section);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Research_Section from '../components/Research_Section'
	
	// import Publication_Section from '../components/Publication_Section'
	
	// import About_Section from '../components/About_Section'
	
	
	var marked = __webpack_require__(12);
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.render = function render() {
	    var blobs = this.props.data.allContentfulBlob.edges;
	    var reduced = blobs.reduce(function (prev, curr) {
	      var _extends2;
	
	      var title = curr.node.title;
	      var body = curr.node.body.body;
	      return _extends({}, prev, (_extends2 = {}, _extends2[title] = {
	        title: title,
	        body: body
	      }, _extends2));
	    }, []);
	    // const publications = this.props.data.allContentfulPublication.edges;
	    var news = this.props.data.allContentfulNews.edges;
	
	    return _react2.default.createElement(
	      'div',
	      { style: { minHeight: '100vh' } },
	      _react2.default.createElement(_Hero_Section2.default, { text: reduced["hero"].body }),
	      _react2.default.createElement(_News_Section2.default, { news: news }),
	      _react2.default.createElement(_Contact_Section2.default, { text: reduced["Contact"].body }),
	      _react2.default.createElement(_Affiliations_Section2.default, null)
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-702ce023e0a0239eb9fa.js